import { render, staticRenderFns } from "./DownloadOptions.vue?vue&type=template&id=130e89ca&scoped=true&"
import script from "./DownloadOptions.vue?vue&type=script&lang=js&"
export * from "./DownloadOptions.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOptions.vue?vue&type=style&index=0&id=130e89ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e89ca",
  null
  
)

export default component.exports